module.exports = __webpack_public_path__ + "static/media/07_sydney-coquitlam.eca68b15.jpg";